import { useState, useEffect } from "react";

export default function Toast({ title, message, type = "info", isSticky }) {
  const [showToast, setShowToast] = useState(true);
  const [toastStyle, setToastStyle] = useState({});

  useEffect(() => {
    switch (type) {
      // green
      case "success":
        setToastStyle({
          border: "border-ui-green",
          color: "text-ui-green ring-ui-green-light",
          icon: "#ui-icon-circle-solid-checkmark",
        });
        break;

      // red
      case "error":
        setToastStyle({
          border: "border-ui-red",
          color: "text-ui-red ring-ui-red-light",
          icon: "#ui-icon-circle-solid-exclamation",
        });
        break;

      // yellow
      case "warning":
        setToastStyle({
          border: "border-ui-yellow",
          color: "text-ui-yellow ring-ui-yellow-light",
          icon: "#ui-icon-circle-solid-exclamation",
        });
        break;

      // blue
      case "info":
      default:
        setToastStyle({
          border: "border-ui-blue",
          color: "text-ui-blue ring-ui-blue-light",
          icon: "#ui-icon-circle-solid-exclamation",
        });
        break;
    }
  }, [type]);

  return showToast ? (
    <div
      className={`container top-0 lg:top-[120px] z-20 ${
        isSticky ? "sticky" : ""
      }`}
    >
      <div
        className={`ui-card mt-4 p-4 relative xl:p-6 border-l-8 shadow-xl ${toastStyle.border}`}
      >
        <div className="flex flex-row">
          <div className="flex items-center mr-4">
            <svg
              className={`ui-icon ring-8 rounded-full w-6 h-6 content-center ${toastStyle.color}`}
              focusable="false"
              aria-hidden="true"
              role="presentation"
            >
              <use href={toastStyle.icon}></use>
            </svg>
          </div>
          <div>
            <div className="flex flex-row justify-between">
              <h2 className="text-lg font-body font-semibold my-auto">
                {title}
              </h2>
              <button
                className="ui-default-dialog-close"
                aria-label="close toast alert"
                onClick={() => setShowToast(false)}
              >
                <svg
                  className="ui-icon h-3.5 w-3.5"
                  focusable="false"
                  aria-hidden="true"
                  role="presentation"
                >
                  <use href="#ui-icon-close"></use>
                </svg>
              </button>
            </div>
            {message}
          </div>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
}
